import PropTypes from 'prop-types';
import React from 'react';
import { Panel } from 'react-bootstrap';
import classNames from 'classnames';

import i18n from '../../i18n';
import { Flex, Icon, Text } from '@homeexchange/design';

export default class AddPaymentMethod extends React.PureComponent {
    static propTypes = {
        children: PropTypes.element,
        is3xPaymentFromFinalization: PropTypes.bool,
        needToBuyGp: PropTypes.bool,
        disabled: PropTypes.bool,
        disabledMessage: PropTypes.node,
        isOpen: PropTypes.bool,
        onOpenChange: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false
        };

        this.toggleCollapse = this.toggleCollapse.bind(this);
    }

    toggleCollapse() {
        const nextOpen = !this.isExpanded();
        if (this.props.onOpenChange) {
            this.props.onOpenChange(nextOpen);
        } else {
            this.setState({ open: nextOpen });
        }
    }

    isExpanded() {
        return this.props.isOpen !== undefined ? this.props.isOpen : this.state.open;
    }

    render() {
        const { children, disabled, disabledMessage } = this.props;
        const open = this.isExpanded();

        const childrenWithProps = React.Children.map(children, (child) =>
            React.cloneElement(child, {
                collapseParentPanel: this.toggleCollapse,
                is3xPaymentFromFinalization: this.props.is3xPaymentFromFinalization,
                needToBuyGp: this.props.needToBuyGp
            })
        );

        return (
            <Panel className="add-payment-method" expanded={!disabled ? open : false} onToggle={true}>
                <Panel.Heading>
                    <Panel.Title>
                        {disabled ? (
                            <Flex
                                direction="row"
                                justifyContent="space-between"
                                isFullWidth
                                flexWrap="nowrap"
                                className="mt-1 mb-1"
                            >
                                <Flex direction="column" gap="1">
                                    <span>{i18n.t('billing:payment-method.add')}</span>
                                    <Text color="warning" size="sm" className="add-payment-method-warning">
                                        {disabledMessage}
                                    </Text>
                                </Flex>
                                <Icon name="Lock" size="large"></Icon>
                            </Flex>
                        ) : (
                            <button type="button" onClick={this.toggleCollapse}>
                                <span>{i18n.t('billing:payment-method.add')}</span>
                                <Icon
                                    name="ChevronDown"
                                    size="large"
                                    className={classNames('down-arrow', { open })}
                                />
                            </button>
                        )}
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Collapse>
                    <Panel.Body>{childrenWithProps}</Panel.Body>
                </Panel.Collapse>
            </Panel>
        );
    }
}
